<template>
  <section class="flex flex-col">
    <h2
      class="uppercase text-center font-druk font-medium text-display-11 leading-10 tracking-02-em md:text-display-14 md:leading-13 mb-6 lg:mb-12"
    >
      {{ title }}
    </h2>
    <template v-if="!hasItems">
      <span
        class="uppercase text-center font-druk text-display-7 tracking-02-em leading-7 md:text-display-11 md:leading-12"
      >{{ $messages('community.error.no_content') }}</span>
    </template>
    <template
      v-for="(item, index) in items"
      :key="index"
    >
      <article
        class="grid gap-x-4 my-6 relative"
      >
        <MajorityUiMajorityLink
          class="absolute w-full h-full z-10"
          tracking-name="communityItemList"
          tracking-type="community content"
          :to="getTo(item)"
        />
        <figure
          class="hidden md:flex select-none relative justify-center items-center bg-middle-light ar-4by3"
        >
          <MajorityUiMajorityImage
            :src="item.imageUrl"
            :alt="item.title"
            class="object-cover w-full h-full absolute top-0"
            fade-in
            lazy
            :optmize-options="{ w: 320 }"
          />
        </figure>
        <section class="my-auto">
          <h4
            class="uppercase font-gt-america-extended text-tiny -tracking-04-em leading-3 md:text-smallest md:leading-4 text-dusty-gray mb-1 md:mb-2"
          >
            {{ getCategory(item) }}
          </h4>
          <h3
            class="font-bold text-smaller leading-6 tracking-02-em md:text-display-7 md:leading-9"
          >
            <MajorityUiMajorityLink
              class="no-underline"
              tracking-name="communityItemList"
              tracking-type="community content"
              :to="getTo(item)"
              :text="item.title"
            />
          </h3>
          <div
            v-if="hasTag(item)"
            class="hidden md:block mt-2"
          >
            <span class="uppercase select-none font-medium tracking-01-em leading-4 md:leading-5 text-tiny md:text-smaller bg-bright-yellow py-px md:py-2px px-half-space">{{ item.tag.name }}</span>
          </div>
        </section>
      </article>
      <hr
        v-if="items[index + 1]"
        class="md:hidden my-0"
      >
    </template>
  </section>
</template>

<script>
import { isNullOrUndefined } from '@/utils/comparators'
export default {
  props: {
    title: {
      type: String,
      required: true,
      default: ''
    },
    items: {
      type: Array,
      required: true,
      default: () => [],
      validator: val => val.every(item => !isNullOrUndefined(item) && !isNullOrUndefined(item.slug) && !isNullOrUndefined(item.type) && !isNullOrUndefined(item.title) && !isNullOrUndefined(item.imageUrl))
    }
  },
  computed: {
    hasItems () {
      return this.items.length > 0
    }
  },
  methods: {
    getCategory (item) {
      if (!isNullOrUndefined(item.category)) {
        return item.category.name
      }

      if (item.type === 'video') {
        return this.$messages('page_labels.majority_tv')
      }

      if (item.type === 'event') {
        return this.$messages('community.labels.event')
      }

      if (item.type === 'article') {
        return this.$messages('community.labels.article')
      }

      return ''
    },
    hasTag (item) {
      return !isNullOrUndefined(item.tag)
    },
    getTo (item) {
      if (item.type === 'video') {
        return this.$mRouter.getLocalRoute({ name: 'community-majority-tv-slug', params: { slug: item.slug } })
      }

      if (item.type === 'event') {
        return this.$mRouter.getLocalRoute({ name: 'community-event-slug', params: { slug: item.slug } })
      }

      if (item.type === 'discount') {
        return this.$mRouter.getLocalRoute({ name: 'community-discount-slug', params: { slug: item.slug } })
      }

      return this.$mRouter.getLocalRoute({ name: 'community-article-slug', params: { slug: item.slug } })
    }
  }
}
</script>

<style lang="postcss" scoped>
.grid {
    grid-template-columns: auto;
    grid-template-rows: auto auto;

    @screen md {
        grid-template-columns: 145px auto;
        grid-template-rows: auto;
    }
}

article:hover h3 {
    @apply underline;
}
</style>
